export class ValueAndLabelModel {
    value: string;
    label: string;

    constructor(value?: string, label?: string) {
        this.value = value;
        this.label = label;
    }
}